<template>
    <div class="apply_sence_container" id="apply_sence">
        <div class="apply_sence_gradient_1">
            <div class="apply_sence_gradient_2">
                <div class="apply_sence_main">
                    <div class="apply_sence_title">{{ $t('index.apply_sence_title') }}</div>
                    <div class="apply_sence_desc">{{ $t('index.apply_sence_desc') }}</div>

                    <div class="apply_sence_menu">
                        <div 
                            class="apply_sence_menu_item" 
                            v-for="(item, index) in showImgMenuArr" :key="'show-img-menu-' + index" 
                            :class="{active: currentOpenMenuIndex === index}" 
                            @click="showBottomContent(index)">
                            <img v-lazy="item" @error="handleError" alt="ICON" />
                            {{ $t('index.apply_sence_menu_item_title_'+index) }}
                        </div>
                    </div>

                    <div class="apply_sence_content animate__animated animate__fadeInLeft" v-if="currentOpenMenuIndex === 0">
                        <div class="apply_sence_content_left">
                            <p>{{ $t('index.apply_sence_content_left_title_0') }}</p>
                            <p>{{ $t('index.apply_sence_content_left_desc_0') }}</p>
                            <div class="apply_sence_content_right">
                                <div class="sence_add_box" :id="'sence_add_box_' + currentOpenMenuIndex">
                                    <video 
                                        v-if="video0Loaded" 
                                        v-for="(item, index) in senceVideos.game_center" :key="'game_center_' + index" 
                                        :poster="index === 1 ? applySenceComponentsPosterB : applySenceComponentsPosterS" 
                                        :autoplay="index === 1 ? true : false" 
                                        :loop="true" 
                                        class="spi01" 
                                        :class="{spi02: index === 1}" 
                                        data-object-fit="true" 
                                        x5-video-player-type="h5" 
                                        @click.stop="handleVideoClick($event, currentOpenMenuIndex)" 
                                        controls 
                                        muted 
                                        playsinline 
                                        webkit-playsinline>
                                        <source :src="item" type="video/mp4">
                                        Sorry, your browser does not support embedded videos.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="apply_sence_content animate__animated animate__fadeInRight" v-if="currentOpenMenuIndex === 1">
                        <div class="apply_sence_content_left">
                            <p>{{ $t('index.apply_sence_content_left_title_1') }}</p>
                            <p>{{ $t('index.apply_sence_content_left_desc_1') }}</p>
                            <div class="apply_sence_content_right">
                                <div class="sence_add_box" :id="'sence_add_box_' + currentOpenMenuIndex">
                                    <video 
                                        v-if="video1Loaded" 
                                        v-for="(item, index) in senceVideos.live_streaming" :key="'live_streaming_' + index" 
                                        :poster="index === 1 ? applySenceComponentsPosterB : applySenceComponentsPosterS" 
                                        :autoplay="index === 1 ? true : false" 
                                        :loop="true" 
                                        class="spi01" 
                                        :class="{spi02: index === 1}" 
                                        data-object-fit="true" 
                                        x5-video-player-type="h5" 
                                        @click.stop="handleVideoClick($event, currentOpenMenuIndex)" 
                                        controls 
                                        muted 
                                        playsinline 
                                        webkit-playsinline>
                                        <source :src="item" type="video/mp4">
                                        Sorry, your browser does not support embedded videos.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="apply_sence_content animate__animated animate__fadeInLeft" v-if="currentOpenMenuIndex === 2">
                        <div class="apply_sence_content_left">
                            <p>{{ $t('index.apply_sence_content_left_title_2') }}</p>
                            <p>{{ $t('index.apply_sence_content_left_desc_2') }}</p>
                            <div class="apply_sence_content_right">
                                <div class="sence_add_box" :id="'sence_add_box_' + currentOpenMenuIndex">
                                    <video 
                                        v-if="video2Loaded" 
                                        v-for="(item, index) in senceVideos.chat_room" :key="'chat_room_' + index" 
                                        :poster="index === 1 ? applySenceComponentsPosterB : applySenceComponentsPosterS" 
                                        :autoplay="index === 1 ? true : false" 
                                        :loop="true" 
                                        class="spi01" 
                                        :class="{spi02: index === 1}" 
                                        data-object-fit="true" 
                                        x5-video-player-type="h5" 
                                        @click.stop="handleVideoClick($event, currentOpenMenuIndex)" 
                                        controls 
                                        muted 
                                        playsinline 
                                        webkit-playsinline>
                                        <source :src="item" type="video/mp4">
                                        Sorry, your browser does not support embedded videos.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="apply_sence_content animate__animated animate__fadeInRight" v-if="currentOpenMenuIndex === 3">
                        <div class="apply_sence_content_left">
                            <p>{{ $t('index.apply_sence_content_left_title_3') }}</p>
                            <p>{{ $t('index.apply_sence_content_left_desc_3') }}</p>
                            <div class="apply_sence_content_right">
                                <div class="sence_add_box" :id="'sence_add_box_' + currentOpenMenuIndex">
                                    <video 
                                        v-if="video3Loaded" 
                                        v-for="(item, index) in senceVideos.battle_social" :key="'battle_social_' + index" 
                                        :poster="index === 1 ? applySenceComponentsPosterB : applySenceComponentsPosterS" 
                                        :autoplay="index === 1 ? true : false" 
                                        :loop="true" 
                                        class="spi01" 
                                        :class="{spi02: index === 1}" 
                                        data-object-fit="true" 
                                        x5-video-player-type="h5" 
                                        @click.stop="handleVideoClick($event, currentOpenMenuIndex)" 
                                        controls 
                                        muted 
                                        playsinline 
                                        webkit-playsinline>
                                        <source :src="item" type="video/mp4">
                                        Sorry, your browser does not support embedded videos.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import applySenceComponentsPosterB from '@/../public/static/imgs/gameDetailViewPosterMobile01.png';
import applySenceComponentsPosterS from '@/../public/static/imgs/gameDetailViewPosterMobile02.png';

export default {
    name: 'ApplySencePc',
    data() {
        return {
            tips: 'Hello World',
            applySenceComponentsPosterB,
            applySenceComponentsPosterS,
            // Apply Sence 默认选中INDEX
            currentOpenMenuIndex: 0,
            video0Loaded        : true,
            video1Loaded        : false,
            video2Loaded        : false,
            video3Loaded        : false,
            showImgMenuArr: [
                require('@/assets/static/imgs/common/m/icon_zoom.png'),
                require('@/assets/static/imgs/common/m/icon_live.png'),
                require('@/assets/static/imgs/common/m/icon_chat.png'),
                require('@/assets/static/imgs/common/m/icon_1v1.png')
            ],
            senceVideos: {
                game_center: [
                    require('@/../public/static/apply-sence/game-center-01.mp4'),
                    require('@/../public/static/apply-sence/game-center-02.mp4'),
                    require('@/../public/static/apply-sence/game-center-04.mp4')
                ],
                live_streaming: [
                    require('@/../public/static/apply-sence/1v1-social-01.mp4'),
                    require('@/../public/static/apply-sence/1v1-social-02.mp4'),
                    require('@/../public/static/apply-sence/1v1-social-03.mp4')
                ],
                chat_room: [
                    require('@/../public/static/apply-sence/chat-room-01.mp4'),
                    require('@/../public/static/apply-sence/chat-room-02.mp4'),
                    require('@/../public/static/apply-sence/chat-room-03.mp4')
                ],
                battle_social: [
                    require('@/../public/static/apply-sence/1v1-social-01.mp4'),
                    require('@/../public/static/apply-sence/1v1-social-02.mp4'),
                    require('@/../public/static/apply-sence/1v1-social-03.mp4')
                ]
            }
        }
    },

    methods: {
        // 中部导航菜单（Apply Sence）：子菜单鼠标移入事件
		showBottomContent(index)
		{
			// console.log('=== App__showBottomContent__index >>>', index);
			this.currentOpenMenuIndex = index;
            switch(index) {
                case 0:
                    this.video0Loaded = true;
                    break;
                case 1:
                    this.video1Loaded = true;
                    break;
                case 2:
                    this.video2Loaded = true;
                    break;
                case 3:
                    this.video3Loaded = true;
                    break;
                default:
                    break;
            }

            // Reload the video element to apply the new source
            let elements = document.getElementsByClassName('spi01');
            // console.log(elements);
            this.$nextTick(() => {
                for(let i = 0; i < elements.length; i++) {
                    elements[i].load();
                    // elements[i].style.borderColor = 'red';
                }
            });
		},

        // 点击某个视频，改变样式（不好使）
        handleVideoClick(event, currentOpenMenuIndex)
        {
            // 获取所有 video 元素
            const containerId = 'sence_add_box_' + currentOpenMenuIndex;
            const videos      = document.querySelectorAll(`#${containerId} video`);

            // 遍历所有 video 元素并重置它们的类
            videos.forEach(video => {
                video.classList.remove('spi02');
                video.classList.add('spi01');
            });

            // 为当前被点击的元素添加 'spi02' 类
            const clickedVideo = event.currentTarget;
            clickedVideo.classList.add('spi02');
        },

        handleError(event)
        {
            return;
            /* console.log('event >>>', event);
            event.target.src = require('@/assets/static/imgs/common/google-cloud.png'); */
        }
    }
}
</script>

<style lang="less" scoped>
.apply_sence_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:var(--com-base-container-wm);height:auto;
	.apply_sence_gradient_1{
		width:inherit;height:inherit;
		background:linear-gradient(135deg, rgba(210, 223, 244, 1), rgba(236, 243, 255, 1), rgba(225, 240, 255, 1), rgba(243, 240, 255, 1));
		.apply_sence_gradient_2{
			width:inherit;height:inherit;
            /* background-position:left bottom;
            background-repeat:no-repeat;
			background-size:374px 400px; */
			.apply_sence_main{
				margin:0 auto;padding-top:75px;
				width:var(--com-base-container-wm);height:inherit;
				/* background:#CCC; */
				.apply_sence_title{
					height:50px;line-height:50px;
					font-size:var(--com-base-fz-58);font-weight:bold;color:var(--com-main-ft-color);text-align:center;
				}
				.apply_sence_desc{
					height:80px;line-height:80px;
					font-size:var(--com-base-fz-28);font-weight:normal;color:#5C626B;text-align:center;
				}
				.apply_sence_menu{
					margin:0 auto;margin-top:30px;
                    width:var(--com-base-content-wm);
					display:flex;justify-content:center;align-items:center;flex-wrap:wrap;
					gap:26px;
					.apply_sence_menu_item{
						width:330px;height:88px;
						border-radius:18px;border:2px solid #FFF;background:#F5F9FF;
						display:flex;justify-content:flex-start;align-items:center;
                        padding-left:30px;
						font-size:var(--com-base-fz-28);color:#1D55FF;font-weight:bold;
						cursor:pointer;
						img{
                            width:54px;height:54px;
                            margin-right:5px;
                        }
						&:hover{
							border-color:#004BF9;background:#FFF !important;
						}
					}
					.active{
						border-color:#004BF9;background:#FFF !important;
					}
				}
				.apply_sence_content{
					margin:0 auto;margin-top:50px;
                    padding-bottom:40px;
					width:var(--com-base-content-wm);height:auto;
					border:2px solid rgba(255, 0, 0, 0.4);border:2px solid rgba(255, 255, 255, .4);border-radius:18px;
					background:rgba(255, 255, 255, .3);
					display:flex;flex-direction:column;justify-content:flex-start;align-items:center;
					.apply_sence_content_left{
						width:100%;height:auto;
						padding:40px;
						border-radius:18px 0 0 18px;
                        display:flex;flex-direction:column;justify-content:center;align-items:flex-start;
						p:nth-child(1){
							font-size:var(--com-base-fz-48);color:#4C6B95;font-weight:bold;
						}
						p:nth-child(2){
							padding-top:20px;
							font-size:var(--com-base-fz-24);color:#798DA6;
							line-height:1.6;
						}
                        .apply_sence_content_right{
                            position:relative;
                            width:100%;height:484px;
                            margin-top:50px;
                            .sence_add_box{
                                position:absolute;top:0;right:0;left:0;margin:auto;
                                display:flex;justify-content:space-between;align-items:center;
                                gap:35px;
                                pointer-events:auto;
                                video{
                                    width:244px;height:484px;
                                    border:5px solid #FFF;border-radius:24px;
                                    object-fit:cover;
                                    box-shadow:0 4px 20px 0 rgba(0, 0, 0, .3);
                                }
                                .spi01{
                                    pointer-events:auto;
                                }
                                .spi02{
                                    position:absolute;left:0;right:0;margin:auto;
                                    width:270px;height:536px;
                                    z-index:99;
                                    pointer-events:auto;
                                }
                            }
                        }
					}
				}
			}
		}
	}
}
</style>